import React, { useContext } from "react";
import styled from "styled-components";
import { Box } from "@motorata/base-ui.components.atoms._atoms";
import { IconButton } from "@motorata/base-ui.components.atoms.button";
import { useRouter } from "next/navigation";
import Icon from "@motorata/base-ui.components.atoms.icon";
import { AccountContext } from "@/providers/AccountProvider";

const MobileNavigation = ({ setModal }) => {
  const router = useRouter();
  const { hasToken, state } = useContext(AccountContext);

  const handleAddButton = () => {
    if(hasToken){
      if(state === "account"){
        router.push("/konto/dodaj-ogloszenie")
        return
      }
    }
    setModal("account")
  }

  return (
    <Wrapper>
      <IconButton
        size="XL"
        background="none"
        onClick={() => router.push("/oferty")}
        icon="list"
      />
      <AddButton onClick={handleAddButton}>
        <Icon icon="plus" color="white" size="25px" />
        {/*Dodaj <br/> ogłoszenie*/}
      </AddButton>
      <IconButton
        size="XL"
        background="none"
        onClick={() => setModal("search")}
        icon="search"
      />
    </Wrapper>
  );
};

export default MobileNavigation;

const AddButton = styled.button`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: ${({ theme }) => theme.color.primary};
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  font-size: 10px;
  `;

const Wrapper = styled(Box)`
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  box-shadow: ${({ theme }) => theme.variable.boxShadow};
  justify-content: space-around;
  height: 50px;
  align-items: center;
  z-index: 2;
  border-top: 1px solid ${({ theme }) => theme.color.fourth};
  
  @media (max-width: 900px){
    display: flex;
  }
`
